import React from 'react';
import { useParams } from 'react-router-dom';
import { Player } from '../models/player';
import { useEffect, useState } from 'react';
import httpService from '../api/HttpService';
import { CS_Player } from '../models/cuescore-models';
import cuescoreService from '../api/CuescoreService';
import { MatchResult } from '../models/match-result';
import { MatchReport } from './match-report';
import { Badge, Button, ButtonGroup } from 'react-bootstrap';
import { MatchStatisticsDTO } from '../models/match-statistics-dto';
import { VictoryPie, VictoryTheme } from 'victory';


interface PlayerURLParams {
    playerId: string;
}


export const PlayerDetails = () => {
    const { playerId } = useParams<PlayerURLParams>();

    const [fetchedPlayer, setFetchedPlayer] = useState<Player | null>(null);
    const [knownId, setKnownId] = useState<string>('');
    const [shortId, setShortId] = useState<string>('');
    const [csPlayer, setCsPlayer] = useState<CS_Player>();
    const [selectedOption, setSelectedOption] = useState<number>(0);

    const updateShortId = async (knownId: string, shortId: string) => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
        };

        const response = await fetch(`${httpService.BaseUrl}api/players?knownId=${knownId}&shortId=${shortId}`, requestOptions);
    }

    useEffect(() => {

        const fetchPlayer = async () => {
            const url = `api/players/${playerId}`;
            let data = await httpService.anonGet<Player>(url);

            if (data.altId) {
                const csp = await cuescoreService.getPlayerInfo(data.altId);
                if (csp) {
                    data.imageUrl = csp.image;
                    data.countryImageUrl = csp.country.image;
                }
            }

            setFetchedPlayer(data);
        };
        fetchPlayer();

    }, [playerId]);

    const goToCuescore = () => {
        if (fetchedPlayer) {
            window.open(`https://cuescore.com/player/p/${fetchedPlayer.altId}`, '_blank');
        }
    }

    const goToDDBU = () => {
        if (fetchedPlayer) {
            window.open(`https://ddbu-admin.dk/external/spillere.php?licensnr=${fetchedPlayer.licenseNumber}`, '_blank');
        }
    }

    return (
        <>
            {fetchedPlayer &&
                <div>
                    <div className="header">
                        <h1>{fetchedPlayer?.firstName} {fetchedPlayer?.lastName} {fetchedPlayer?.hasEmail && <Badge variant='primary'>Verified</Badge>}</h1>
                    </div>

                    <div className='d-flex justify-content-between'>
                        <div className='d-flex flex-column justify-content-around' style={{ gap: '10px' }}>
                            {fetchedPlayer.altId ?
                                <Button onClick={goToCuescore}>Go to cuescore profile</Button>
                                :
                                // <Button variant='secondary'>Link with cuescore</Button>
                                <label>No cuescore id</label>
                            }
                            {
                                fetchedPlayer.licenseNumber &&
                                <Button onClick={goToDDBU}>Go to ddbu profile</Button>
                            }
                        </div>
                        <div>
                            {fetchedPlayer.imageUrl && (
                                <img
                                    src={fetchedPlayer.imageUrl}
                                    alt={`${fetchedPlayer.firstName} ${fetchedPlayer.lastName}`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }}
                                />
                            )}
                        </div>
                    </div>
                    <h4>Filter view</h4>
                    <ButtonGroup className="mb-3">
                        {['All', 'Tournament', 'Practice'].map((option, idx) => (
                            <Button
                                key={option}
                                variant={selectedOption === idx ? 'primary' : 'outline-primary'}
                                onClick={() => setSelectedOption(idx)}
                                active={selectedOption === idx}
                            >
                                {option}
                            </Button>
                        ))}
                    </ButtonGroup>
                    <PlayerMatchStats playerId={playerId} filterOption={selectedOption} />
                    <PlayerMatchResults playerId={playerId} filterOption={selectedOption} />
                </div>
            }
        </>
    );
};


const PlayerMatchStats = (props: MatchProps) => {
    const { playerId, filterOption } = props;

    const [stats, setStats] = useState<MatchStatisticsDTO>();

    useEffect(() => {
        const load = async () => {
            try {
                var s = await httpService.anonGet<MatchStatisticsDTO>(`api/matchResults/statistics/${playerId}?filterOptions=${filterOption}`);
                setStats(s);
            }
            catch (e) {
                setStats(undefined);
            }
        };

        load();
    }, [playerId, filterOption]);

    const pieData = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
    ];

    const barData = [
        { name: 'Bucket 1', value: 12 },
        { name: 'Bucket 2', value: 18 },
    ];

    const matchesWonPercentage = stats && (stats.matchesWon / stats.totalMatches * 100).toFixed(0);
    const matchesLostPercentage = stats && (stats.matchesLost / stats.totalMatches * 100).toFixed(0);
    const totalFrames = stats && stats.framesLost + stats.framesWon;
    const framesWonPercentage = stats && totalFrames && (stats.framesWon / totalFrames * 100).toFixed(0);
    const framesLostPercentage = stats && totalFrames && (stats.framesLost / totalFrames * 100).toFixed(0);

    const top10HighBreaks = stats?.highBreaks?.slice(0, 10).join(', ') ?? '';

    let header = "Statistics";

    if (filterOption == 1) {
        header += " (tournament)"
    }
    if (filterOption == 2) {
        header += " (practice)"
    }
    return (
        <div>
            <div className="header">
                <h2>{header}</h2>
            </div>
            {!stats &&
                <div>
                    No statistics for selected filter
                </div>}
            {stats &&
                <div>
                    <div className="">
                        <div className="row">
                            <div className="col">
                                <div className='small-header'>Matches played</div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Total:&nbsp;</td>
                                            <td>{stats.totalMatches}</td>
                                        </tr>
                                        <tr>
                                            <td>Won:</td>
                                            <td>{stats.matchesWon} ({matchesWonPercentage} %)</td>
                                        </tr>
                                        <tr>
                                            <td>Lost:</td>
                                            <td>{stats.matchesLost} ({matchesLostPercentage} %)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col">
                                <div className='small-header'>Frames played</div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Total:&nbsp;</td>
                                            <td>{totalFrames}</td>
                                        </tr>
                                        <tr>
                                            <td>Won:</td>
                                            <td>{stats.framesWon} ({framesWonPercentage} %)</td>
                                        </tr>
                                        <tr>
                                            <td>Lost:</td>
                                            <td>{stats.framesLost} ({framesLostPercentage} %)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col">
                                {stats.highBreaks?.length > 0 &&
                                    <div>Highest breaks: {top10HighBreaks}</div>
                                }
                                <div>Points scored (average):&emsp;{stats.pointsScoredAverage.toFixed(1)}</div>
                                <div>Points against (average):&emsp;{stats.pointsAgainstAverage.toFixed(1)}</div>
                            </div>
                        </div>
                    </div>



                </div>
            }

        </div>
    );
}

interface MatchProps {
    playerId: string;
    filterOption: number;
}

const PlayerMatchResults = (props: MatchProps) => {
    const { playerId, filterOption } = props;
    const [matches, setMatches] = useState<MatchResult[]>();

    useEffect(() => {
        const fetch = async () => {
            console.log(filterOption);
            const url = `api/matchresults?playerId=${playerId}&filterOptions=${filterOption}`;
            try {
                const matches = await httpService.get<MatchResult[]>(url);
                setMatches(matches);
            }
            catch (e) {

            }
        }
        fetch();
    }, [playerId, filterOption]);

    let roundName = "";
    let tournamentName = "";

    let header = "Matches";

    if (filterOption == 1) {
        header += " (tournament)"
    }
    if (filterOption == 2) {
        header += " (practice)"
    }

    return (
        <div>
            <div className="header">
                <h2>{header}</h2>
            </div>
            {!matches || matches.length == 0 &&
                <div>
                    No matches for selected filter
                </div>}
            {
                matches?.map(x => {
                    const showRoundname = false; // roundName !== result.roundName;
                    roundName = x.roundName;

                    const showTournamentname = tournamentName !== x.tournamentName;
                    tournamentName = x.tournamentName;
                    return (
                        <div key={x.id}>
                            {showTournamentname && tournamentName && <h4>{x.tournamentName}</h4>}
                            <MatchReport matchResult={x} minHighBreak={10}></MatchReport>
                        </div>
                    );
                })
            }
        </div>
    )
}